<template>
    <div class="pageIntro">
      <h2>Hosted Projects</h2>
    </div>
    <ul class="sites">
        <li><a href="../root_projects/finalApp/">Project Title</a></li>
      
    </ul>
  </template>
  <script>
  export default {
    data() {
      return {
        pics: [
          {
            link: "about",
            imgFile: "about.jpg",
            caption: "My Bio",
          },
          {
            link: "portfolio",
            imgFile: "portrait.jpg",
            caption: "See Projects",
          },
          {
            link: "contact",
            imgFile: "grads.jpg",
            caption: "Lets Talk",
          },
        ],
      };
    },
    emits: ["updateTitle"],
    props: {
      pTitle: String,
    },
    methods: {
      updateTitle(newTitle) {
        this.$emit("updateTitle", newTitle);
      },
    },
  };
  </script>
  <style scoped>
  .directions {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .photoBox {
    width: 24%;
    text-decoration: none;
    color: black;
  }
  </style>
  